import {Site} from './Site'

import './App.css';

function App() {
  return (
    <div className="App">
      <Site/>
    </div>
  );
}
// this is a test commit1
export default App;
